import React from 'react';
import ChatGPTPage from '../chatGPT';

export default function ChatGPTTeacher() {
  return (
    <>
      <ChatGPTPage urlPath={'/AI/teacherNew'} />
    </>
  );
}
